var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEqual(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 179,
    height: 179,
    viewBox: "0 0 179 179",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "akar-icons:equal"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M119.138 104.637H59.6465M119.138 74.8914H59.6465",
    stroke: "white",
    strokeWidth: 14.8728,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M89.3913 164.128C130.461 164.128 163.755 130.834 163.755 89.7641C163.755 48.694 130.461 15.4001 89.3913 15.4001C48.3212 15.4001 15.0273 48.694 15.0273 89.7641C15.0273 130.834 48.3212 164.128 89.3913 164.128Z",
    stroke: "white",
    strokeWidth: 14.8728
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEqual);
export default __webpack_public_path__ + "static/media/equal.16f6f7f0b4f07ce7b7a6cc4b08506973.svg";
export { ForwardRef as ReactComponent };